



























import { Vue, Component, Mixins, Prop } from 'vue-property-decorator'
import Modifiable from '@/mixins/Modifiable'

/**
 * Content panel
 */
@Component({ name: 'v-panel' })
export default class VPanel extends Mixins(Modifiable) {
    /**
     * Whether the panel header has the entry section
     */
    @Prop({ type: Boolean, default: false })
    hasEntry!: boolean

    /**
     * Whether the panel header has the action button section
     */
    @Prop({ type: Boolean, default: true })
    hasActions!: boolean

    /**
     * Style type
     */
    @Prop({ type: String, default: 'primary' })
    type!: 'primary' | 'grey'

    /**
     * Collapse body
     */
    @Prop({ type: Boolean, default: false })
    collapsed!: boolean
}
